import { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import Main from "../hoc/Main";
import { getServerURL } from "../helper/envConfig";
import { ValidateFields } from "../components/validate/ValidateFields";
import ErrorFilter from "../helper/errorFilter";
import api from "../helper/api";
import { toast } from "react-toastify";
import { errorResponse } from "../helper/error";
import SingleError from "../helper/SingleError";
import VideoLinkTable from "../components/VideoLinkTable";
import VideoCategoryTable from "../components/VideoCategoryTable";
const requireField = ["videoUrl"];

export const VideoLink = () => {
  const serverURL = getServerURL();

  const [addModel, setAddModel] = useState(false);

  const addModelOpenFun = () => {
    setSubmitCount(0);
    setErrors({});
    setState({});
    setAddModel(true);
  };
  const addModelCloseFun = () => {
    setAddModel(false);
    setCategory("");
    setCategoryId("");
  }

  const [state, setState] = useState({});
  const [submitCount, setSubmitCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [search] = useState("");
  const [temp, setTemp] = useState(false);
  const [searchTemp] = useState(false);
  const [activeTab, setActiveTab] = useState("videoLink");
  const [category, setCategory] = useState();
  const [categoryList, setCategoryList] = useState([]);
  const [editModel, setEditModel] = useState(false);
  const [id, setId] = useState();
  const [deleteModel, setDeleteModel] = useState(false);
  const [categoryId, setCategoryId] = useState();
  const [videoList, setVideoList] = useState([]);

  const handleChange = (e) => {
    setErrors({});
    const { name, value } = e.target;
    if (submitCount > 0) {
      let validationErrors = ValidateFields({ ...state, [name]: value });
      validationErrors = ErrorFilter(validationErrors, requireField);
      setErrors(validationErrors);

      if (Object.keys(validationErrors).length === 0) {
        delete errors[name];
      }
    }
    setState((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const addVideoLink = () => {
    setTemp(false);
    const updatedValues = { ...state };
    let validationErrors = ValidateFields(updatedValues);
    validationErrors = ErrorFilter(validationErrors, requireField);
    setErrors(validationErrors);
    // console.log(validationErrors);

    if (Object.keys(validationErrors)?.length) {
      Object.entries(validationErrors)?.forEach(([key], i) => {
        if (i === 0)
          document.getElementById(key)?.scrollIntoView({ behavior: "smooth" });
      });
    }
    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      try {
        api
          .postWithToken(`${serverURL}video-playlist-manage`, {
            action: "create",
            videoUrl: state?.videoUrl || "",
            categoryId
          })
          .then(async (res) => {
            setLoading(false);
            if (res?.data?.success === true) {
              addModelCloseFun();
              setTemp(true);
              setState({});
              if (typeof res?.data?.data?.message === "string")
                toast.success(res?.data?.data?.message);
              else toast.success("Video link created successfully");
            }
          })
          .catch((e) => {
            setLoading(false);
            errorResponse(e);
          });
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const handleTabChange = (tabName) => {
    setTemp();
    setState({})
    setCategory('');
    setActiveTab(tabName);
  };

  const getVideoCategory = () => {
    try {
      api
        .getWithToken(`${serverURL}video-playlist-get`)
        .then(async (res) => {
          if (res.data.success) {
            setCategoryList(res?.data);
          }
        })
        .catch((e) => {
          setLoading(false);
          errorResponse(e);
        });
    } catch (error) {
      setLoading(false);
    }
  }

  const addVideoCategory = () => {
    try {
      api.postWithToken(`${serverURL}video-playlist-category`, { category })
        .then(async (res) => {
          if (res?.data?.success === true) {
            toast.success(res.data.message)
            setAddModel(false);
            getVideoCategory();
            setCategory("");
          }
        })
        .catch((e) => {
          setLoading(false);
          errorResponse(e);
        });
    } catch (error) {
      setLoading(false);
    }
  }

  const updateVideoCategory = () => {
    try {
      api
        .patchWithToken(`${serverURL}video-playlist-category/${id}`, { category })
        .then(async (res) => {
          toast.success(res.data.message);
          getVideoCategory();
          setEditModel(false);
        })
        .catch((e) => {
          setLoading(false);
          errorResponse(e);
        });
    } catch (error) {
      setLoading(false);
    }
  }

  const deleteVideoCategory = () => {
    try {
      api
        .deleteWithToken(`${serverURL}video-playlist-delete/${id}`)
        .then(async (res) => {
          if (res.data.success) {
            getVideoCategory();
            toast.success(res?.data?.message);
            setDeleteModel(false);
          }
        })
        .catch((e) => {
          setLoading(false);
          errorResponse(e);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  const handleCategoryChange = (e) => {
    setCategoryId(e.target.value); // Update state with the selected category ID
  };

  useEffect(() => {
    getVideoCategory();
  }, [])

  return (
    <>
      <Main name="Videos Management">
        <div className="d-sm-block d-md-flex d-lg-flex justify-content-between align-items-center pb-3 pt-3">
          <Col md={6} lg={5} xl={7}>
            <h1 className="title mb-0">Videos Link Management</h1>
          </Col>
          <div className="d-flex align-items-center justify-content-end gap-3">
            <div onClick={() => addModelOpenFun()} className="cursor-pointer">
              <img
                src="/images/svg/add.svg"
                className="add-btn"
                title="Add"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="communityPage mb-3">
          <ul className="nav nav-pills" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="video-link-tab"
                data-bs-toggle="pill"
                data-bs-target="#video-link"
                type="button"
                role="tab"
                onClick={() => handleTabChange("videoLink")}
              >
                Video Link
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="video-category-tab"
                data-bs-toggle="pill"
                data-bs-target="#video-category"
                type="button"
                role="tab"
                onClick={() => handleTabChange("videoCategory")}
              >
                Video Category
              </button>
            </li>
          </ul>
        </div>
        <div className="tab-content mt-2" id="pills-tabContent">
          {(activeTab === "videoLink") &&
            <div
              className="tab-pane fade show"
              id="video-link"
              role="tabpanel"
            >
              <VideoLinkTable temp={temp} search={search} searchTemp={searchTemp} videoList={videoList} setVideoList={setVideoList} categoryList={categoryList} />
            </div>
          }

          <div
            className="tab-pane fade show"
            id="video-category"
            role="tabpanel"
          >
            {(activeTab === "videoCategory") &&
              <VideoCategoryTable temp={temp} search={search}
                searchTemp={searchTemp} addVideoCategory={addVideoCategory}
                categoryList={categoryList} setId={setId}
                updateVideoCategory={updateVideoCategory} deleteVideoCategory={deleteVideoCategory}
                deleteModel={deleteModel} setDeleteModel={setDeleteModel}
                category={category} setCategory={setCategory}
                editModel={editModel} setEditModel={setEditModel}
              />}
          </div>
        </div>
      </Main>

      {/* Add user modal */}
      <Modal
        size="lg"
        show={addModel}
        onHide={() => addModelCloseFun()}
        centered
        className="modal-main info-modal"
      >
        <Modal.Header
          className="d-block position-relative border-0 pt-4 px-4"
          closeButton
        >
          <Modal.Title className="text-center">Add Video Link</Modal.Title>
          <div className="d-flex justify-content-center text-center">
            <img src="/images/svg/line.svg" className="mt-2" alt="" />
          </div>
        </Modal.Header>
        <Modal.Body className="mx-md-4 border-0 bg-transparent ctmInput">
          <Row>
            {activeTab === "videoLink" ?
              <>
                <Col md={12}>
                  <label id="description">
                    Video Link <span className="star">*</span>
                  </label>
                  <textarea
                    rows={3}
                    className="form-control px-3"
                    placeholder="Enter video link here"
                    type="text"
                    name="videoUrl"
                    value={state?.videoUrl || ""}
                    onChange={handleChange}
                  />
                  <SingleError error={errors?.videoUrl} />
                </Col>

                <Col md={12}>
                  <label id="description">
                    Video Category <span className="star">*</span>
                  </label>
                  <Form.Select value={categoryId}
                    onChange={handleCategoryChange} >
                    <option>Open this select menu</option>
                    {categoryList?.data?.map((category) => {
                      return (
                        <option value={category?._id}>{category?.category}</option>
                      );
                    })}
                  </Form.Select>
                </Col>
              </>
              :
              <Col md={12}>
                <label id="description">
                  Video Category
                </label>
                <input
                  className="form-control px-3"
                  placeholder="Enter video category here"
                  type="text"
                  name="videoUrl"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                />
              </Col>
            }
          </Row>
          <div className="d-flex  justify-content-center">
            <button
              className={`btn-login bg-main text-uppercase border-0 w-75 my-4 ${Boolean(loading) && "btnDisable"}`}
              disabled={Boolean(loading)}
              onClick={() => {
                // addVideoLink();
                setSubmitCount(1);
                { activeTab === "videoCategory" ? addVideoCategory() : addVideoLink() }
              }}
            >
              Add
              {/* {Boolean(loading) ? "Loading..." : "Add"} */}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
